import { render, staticRenderFns } from "./c_nav_bar.vue?vue&type=template&id=7580cf56&scoped=true"
import script from "./c_nav_bar.vue?vue&type=script&lang=js"
export * from "./c_nav_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580cf56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7580cf56')) {
      api.createRecord('7580cf56', component.options)
    } else {
      api.reload('7580cf56', component.options)
    }
    module.hot.accept("./c_nav_bar.vue?vue&type=template&id=7580cf56&scoped=true", function () {
      api.rerender('7580cf56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_nav_bar.vue"
export default component.exports